import React from "react";

import styles from "./mobile-footer.module.scss";

type Props = {
  primaryButton: React.ReactElement;
  secondaryButton?: React.ReactElement;
};

function MobileFooter({ primaryButton, secondaryButton }: Props) {
  return (
    <div className={styles.footerActionButtons}>
      {secondaryButton}
      {primaryButton}
    </div>
  );
}

export default MobileFooter;
